/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: c50816c02f829ce5fd45835518370ca76216500290adbb1acdffe459ded0cd07
 */
import cn from 'classnames'
import React, { ReactElement } from 'react'
import type { Props as ReactModalProps } from 'react-modal'
import ReactModal from 'react-modal'
import styled from 'styled-components'

import style from './Modal.style'

export type ModalProps = Omit<ReactModalProps, 'aria' | 'children' | 'className' | 'contentLabel' | 'isOpen' | 'onRequestClose' | 'overlayClassName' | 'portalClassName' | 'role' | 'shouldCloseOnEsc' | 'shouldCloseOnOverlayClick'> & {
  children?: React.ReactNode
  className?: string
  closable?: boolean
  decoration?: React.ReactNode
  description?: React.ReactNode
  footer?: React.ReactNode
  onClose?: () => void
  open?: boolean
  title?: string
}

function Modal(props: ModalProps): ReactElement {
  const {
    children,
    className = '',
    closable = true,
    decoration,
    description,
    footer,
    onClose,
    open = false,
    title,
    ...rest
  } = props
  const reactId = React.useId()
  const titleId = title ? `Modal-title-${reactId}` : undefined
  const descriptionId = description ? `Modal-description-${reactId}` : undefined
  const canRequestClose = closable && Boolean(onClose)

  return (
    <ReactModal
      aria={{ describedby: descriptionId, labelledby: titleId, modal: true }}
      bodyOpenClassName='modal-open'
      className='panel'
      contentLabel={title || 'Modal'}
      isOpen={open}
      onRequestClose={canRequestClose ? onClose : undefined}
      overlayClassName='overlay'
      portalClassName={cn('Modal', className)}
      role='dialog'
      shouldCloseOnEsc={canRequestClose}
      shouldCloseOnOverlayClick={canRequestClose}
      {...rest}
    >
      {decoration ? (
        <div aria-hidden={true} className='decoration'>
          {decoration}
        </div>
      ) : null}
      {closable && onClose ? (
        <button
          aria-label='Close dialog'
          className='close'
          onClick={onClose}
          type='button'
        >
          <span aria-hidden={true}>{'×'}</span>
        </button>
      ) : null}
      {title ? (
        <h2 className='title' id={titleId}>
          {title}
        </h2>
      ) : null}
      {description ? (
        <div className='description' id={descriptionId}>
          {description}
        </div>
      ) : null}
      {children ? <div className='body'>{children}</div> : null}
      {footer ? <div className='footer'>{footer}</div> : null}
    </ReactModal>
  )
}

export default styled(Modal)`
  ${style}
`
